module.exports = "./img/d25ba9ac85dedc90d2ba895bc18ece53.png";